import { recordError, flush } from '@firebase/crashlytics';
import { getCrashlytics } from './firebase';

export function logServerMessage() {
  console.log('logging server message now');
}

export function logClientMessage() {
  console.log('logging client message now');
}

export function throwClientError() {
  console.info('throwing client error now');
  throw new Error('This is a test client-side error for testing telemetry.');
}

export function createUnhandledRejection() {
  function fetchData() {
    return new Promise((_resolve, reject) => {
      // Simulate an asynchronous operation that fails
      setTimeout(() => {
        reject(new Error('This is a test rejected promise')); // Reject the promise
      }, 500);
    });
  }
  console.info('rejecting promise now');
  fetchData();
}

export async function throwAndCatchErrorSync(env: string) {
  console.info(`throwing ${env} error with SDK now`);
  try {
    throw new Error(
      `This is a test error for testing telemetry SDK with flush: ${env}`,
    );
  } catch (e) {
    recordError(getCrashlytics(), e, {
      hello: 'world',
      custom_attribute_map: {
        array: [1, 2, 3],
      },
    });
    await flush(getCrashlytics());
  }
}

export function throwAndCatchErrorAsync(env: string) {
  console.info(`throwing ${env} error with SDK now async`);
  try {
    throw new Error(
      `This is a test error for testing telemetry SDK async: ${env}`,
    );
  } catch (e) {
    recordError(getCrashlytics(), e);
  }
}

export function throwUncaughtServerError(context: string) {
  console.info('throwing uncaught server error now');
  console.info(`runtime: ${process.env.NEXT_RUNTIME}`);
  throw new Error(
    `This is a test uncaught server-side error for testing crashlytics: ${context}`,
  );
}
